import { useMatch } from "@tanstack/react-router";
import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { proDriverRecordQuery } from "@/app/ProDrivers/Drivers/GraphQL/proDriverRecordQuery";

export function useProDriverRecord() {
  const match = useMatch({
    from: "/$tenant/$orgId/supplier/{-$supplierId}/pro-drivers/drivers/$id",
  });

  const { data } = useSuspenseGqlQuery(proDriverRecordQuery, {
    id: match.params.id,
  });

  return data.proDriver;
}
